import { render, staticRenderFns } from "./Formulario020.vue?vue&type=template&id=d8af4974"
import script from "./Formulario020.vue?vue&type=script&lang=js"
export * from "./Formulario020.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports